// extracted by mini-css-extract-plugin
export default {"style-configurations__configuration":"nkRd3ePFGlXvZUEhcKPIfw==","style-configurations__configuration--is-selected":"qzbcnteo0Ret2VhW-1bG0g=="};